import React, { ReactElement } from 'react'
import { ProgramDetailsPage } from 'src/ui/page/es/program/details/ProgramDetailsPage'

export const ProgramCopyPage = (): ReactElement => {
  return <ProgramDetailsPage mode="copy" />
}
